import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowRight, ChevronLeft, TriangleAlert } from "lucide-react";
import { LogoLockup } from "@/components/Logo";
import InstallAppHint from "@/components/InstallAppHint";
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleSignInStudent() {
  const backend = process.env.REACT_APP_BACKEND_URL;
  window.location.href = `${backend}/api/auth/google/login?intent=student`;
}

export default function StudentLogin() {
  const { user, loading } = useAuth();
  const [params] = useSearchParams();
  const blocked = params.get("error") === "no_academy";
  if (loading) return <div style={{minHeight:"100vh",display:"grid",placeItems:"center",background:"var(--bg)"}}><div className="label">Loading…</div></div>;
  if (user) return <Navigate to="/student/home" replace />;

  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh" }}>
      <div className="mx-auto flex flex-col" style={{ maxWidth: 460, minHeight: "100vh", borderLeft: "1px solid var(--border)", borderRight: "1px solid var(--border)" }}>
        <div className="p-5">
          <Link to="/" className="inline-flex items-center gap-1.5 label-tiny hover:text-white" data-testid="back-home">
            <ChevronLeft size={14} /> getrolloss.app
          </Link>
        </div>
        <div className="flex-1 flex flex-col justify-center px-7 pb-16">
          <LogoLockup size={32} beltWidth={260} />
          <div className="mt-12">
            {blocked && (
              <div className="mb-6 p-4 rounded-xl flex items-start gap-3" style={{ background: "rgba(255,80,80,0.08)", border: "1px solid rgba(255,80,80,0.35)" }} data-testid="no-academy-notice">
                <TriangleAlert size={16} style={{ color: "rgb(255,120,120)", marginTop: 2, flexShrink: 0 }} />
                <div className="text-[13px] leading-relaxed" style={{ color: "var(--text)" }}>
                  We couldn't tell which academy you're joining. Ask your academy for their invite link or QR code to sign in.
                </div>
              </div>
            )}
            <div className="label" style={{ color: "var(--green)" }}>Student app</div>
            <h1 className="text-[34px] font-bold uppercase tracking-tight mt-2 leading-tight">
              Welcome to<br />the mats.
            </h1>
            <p className="mt-4 text-[15px] leading-relaxed" style={{ color: "var(--text-dim)" }}>
              Reserve classes, track your training streak, and watch your belt progression — all from your phone.
            </p>
            <button onClick={googleSignInStudent} className="btn btn-primary w-full mt-10" data-testid="student-google-signin">
              Continue with Google <ArrowRight size={14}/>
            </button>
            <InstallAppHint />
            <div className="label-tiny text-center mt-5">
              By continuing you agree to RollOSS&apos;s <Link to="/terms" className="underline" data-testid="link-terms">Terms</Link> and <Link to="/privacy" className="underline" data-testid="link-privacy">Privacy Policy</Link>, plus the academy&apos;s training policy.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
